export default __webpack_public_path__ + "images/0760406c96be55e53286f0756d7dbea6-animalwelfare_small.webp";